import { FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';

import ShineStartNextStepInfoModal from 'features/Onboarding/flows/shineStart/components/NextStepInfoModal';
import { OnboardingPageContent } from 'features/Onboarding/pageLayoutStyles';

import SoloKycContent from '../../../pages/UnderReview/components/SoloKycContent';
import Page from '../../components/Page';
import PageProps from '../PageProps';

const ShineStartNextSteps: FC<PageProps> = ({ user }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Page withNoBackButton>
        <OnboardingPageContent>
          <SoloKycContent onViewNextSteps={onOpen} user={user} />
        </OnboardingPageContent>
      </Page>

      <ShineStartNextStepInfoModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default ShineStartNextSteps;
